module.exports = __webpack_public_path__ + "img/ceviche_chop.10afd956.jpg";